import SkeletonLoader from '../components/core/skeletonLoader'

const renderSkeletonLoaders = (num, skeletonClass) => (
    Array.from({length: num}).map((_, index) => (
        <SkeletonLoader key={index} className={skeletonClass || 'input-skeleton'} />
    ))
)

export default renderSkeletonLoaders
